<template>
  <v-card>
    <v-navigation-drawer>
     <!--  <h3 style="margin-left: 30px; margin-top: 0px">welcome to DGME</h3> -->
      <v-list>
        <v-list-item link>
          <v-list-item-icon @click="goTo()">
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-icon @click="goToDashView()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Default View</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item link>
          <v-list-item-icon @click="goToDivision()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Division</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-icon @click="goToDistrict()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>District</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-icon @click="goToThana()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Thana</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

         <v-list-item link>
          <v-list-item-icon @click="goToPO()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Post Office</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


         <v-list-item link>
          <v-list-item-icon @click="goToInstitute()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Institute</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


         <v-list-item link>
          <v-list-item-icon @click="goToDesignation()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Designation</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-icon @click="goToDepartment()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Department</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-icon @click="goToRole()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Role</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

         <v-list-item link>
          <v-list-item-icon @click="goToEduType()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Education Type</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-icon @click="goToTeacher()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Teacher</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

          <v-list-item link>
          <v-list-item-icon @click="goToStudent()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Student</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-item>

          <v-list-item link>
          <v-list-item-icon @click="goToBookDetails()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Book Details</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         </v-list-item>

          <v-list-item link>
          <v-list-item-icon @click="goToEContent()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>E-Content</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

          <v-list-item link>
          <v-list-item-icon @click="goToWebPortal()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Web Portal</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item link>
          <v-list-item-icon @click="goToWebPortal()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item link>
          <v-list-item-icon @click="goToWebPortal()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Template</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
     <!--    <v-list-item link>
          <v-list-item-icon @click="goToDashView()">
            <v-icon>mdi-forum</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Default View</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        
      </v-list>

    </v-navigation-drawer>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
    
    };
  },
  methods: {
    goTo() {
      this.$router.push("/");
    },
    goToDivision() {
      this.$router.push("/division-list");
    },
    goToInstitute() {
      this.$router.push("/institute-list");
    },
     goToDistrict() {
      this.$router.push("/district-list");
    },
     goToThana() {
      this.$router.push("/thana-list");
    },
    goToDepartment(){
      this.$router.push("/department-list");
    },
    goToPO(){
      this.$router.push("/post-office-list");
    },
    goToTeacher(){
      this.$router.push("/teacher-list");
    },
    goToStudent(){
      this.$router.push("/student-list");
    },
    goToEduType(){
      this.$router.push("/education-type-list");
    },
    goToDesignation(){
      this.$router.push("/designation-list");
    },
     goToRole(){
      this.$router.push("/role-list");
    },
     goToBookDetails(){
      this.$router.push("/Book-Details");
    },
    goToEContent(){
      this.$router.push("/e-content-list");
    },
    goToDashView(){
      this.$router.push("/dash-view");
    },
     goToWebPortal(){
      this.$router.push("/web-portal-list");
    },
  },
};
</script>
